function updateCheckoutButtonPrice() {

  const checkoutBtn = document.getElementById("CartDrawer-Checkout");
  const totalEl = document.querySelector('[data-est-total]');

  if (!checkoutBtn || !totalEl) return;

  const amount = parseInt(totalEl.getAttribute('data-est-total'), 10);

  const formatted = (amount / 100).toFixed(2).replace('.', ',') + '€';

  checkoutBtn.innerText = "VALIDER MA COMMANDE - " + formatted;
}


// Initial load
document.addEventListener("DOMContentLoaded", updateCheckoutButtonPrice);


// 🔥 MutationObserver (IMPORTANT)
const observer = new MutationObserver(() => {
  updateCheckoutButtonPrice();
});

const target = document.querySelector('[data-est-total]');

if (target) {
  observer.observe(target, {
    attributes: true,   // 👈 key point (attribute change ho raha hai)
    attributeFilter: ['data-est-total']
  });
}

// initial load
document.addEventListener("DOMContentLoaded", updateCheckoutButtonPrice);

// cart update (important)
document.addEventListener("cart:updated", updateCheckoutButtonPrice);

// fallback
setInterval(updateCheckoutButtonPrice, 3000);



jQuery(document).ready(function () {




    var mySwiper = new Swiper('.products-slider', {
        speed: 1000,
        spaceBetween: 5,
        initialSlide: 1,
        //truewrapper adoptsheight of active slide
        autoHeight: false,
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        // delay between transitions in ms
        autoplay: {
            delay: 5000
        },
        autoplayStopOnLast: false, // loop false also
        // If we need pagination
        breakpoints: {
            300: {
                slidesPerView: 1,
            },
            400: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-nexts',
            prevEl: '.swiper-button-prevs'
        },

        effect: 'slide',
        // Distance between slides in px.
        //
        slidesPerView: 4,
        //
        centeredSlides: false,
        //
        slidesOffsetBefore: 0,
        //
        grabCursor: true
    });

    var mySwiper = new Swiper('.video-slider', {
        speed: 1000,
        spaceBetween: 18,
        initialSlide: 1,
        //truewrapper adoptsheight of active slide
        autoHeight: false,
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        // delay between transitions in ms
        autoplay: {
            delay: 5000
        },
        autoplayStopOnLast: false, // loop false also
        // If we need pagination


        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-nexts',
            prevEl: '.swiper-button-prevs'
        },

        effect: 'slide',
        // Distance between slides in px.
        //
        slidesPerView: 4,
        //
        centeredSlides: false,
        //
        slidesOffsetBefore: 0,
        //
        grabCursor: true,
        breakpoints: {
            300: {
                slidesPerView: 1,
            },
            400: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
            }
        },
    });

});



document.addEventListener("DOMContentLoaded", function () {
  const plusBtn = document.querySelector(".qty-btn.plus");
  const minusBtn = document.querySelector(".qty-btn.minus");
  const customInput = document.querySelector(".qty-input");
  const shopifyInput = document.querySelector(".quantity__input"); // Shopify default qty input

  function syncToShopify(value) {
    if (shopifyInput) {
      shopifyInput.value = value;
      shopifyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  plusBtn.addEventListener("click", function () {
    let val = parseInt(customInput.value) || 1;
    val++;
    customInput.value = val;
    syncToShopify(val);
  });

  minusBtn.addEventListener("click", function () {
    let val = parseInt(customInput.value) || 1;
    if (val > 1) val--;
    customInput.value = val;
    syncToShopify(val);
  });

  // When Shopify input changes manually
  if (shopifyInput) {
    shopifyInput.addEventListener("change", function () {
      customInput.value = shopifyInput.value;
    });
  }
});


document.addEventListener('DOMContentLoaded', () => {

  if (window.innerWidth < 768) return; // mobile untouched

  document.querySelectorAll('header-menu details').forEach(details => {
    const summary = details.querySelector('summary');

    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });

    // stop click toggle on desktop
    summary.addEventListener('click', e => {
      e.preventDefault();
    });
  });

});

